import * as React from "react"
import {useEffect} from "react"
import {Box} from "@mui/material";

import {REVERSE_MATCHER_ROUTES} from "@constants";
import PageWrapper from "../../@PageWrapper";
import {MatchersSkeleton} from "../@components";
import {useReverseMatcherItems} from "./@hooks";
import {clearReverseMatcherSignals, isReverseMatcherLoading} from "./@signals";
import ReverseMatcherContent from "./Content";


export default function ReverseMatcherPage() {
	const { handleSubmit } = useReverseMatcherItems()

	useEffect(() => {
		const params = new URLSearchParams(window.location.search)
		const idMapping = params.get('id_mapping')
		handleSubmit(idMapping)
		return clearReverseMatcherSignals
	}, [])

	return <PageWrapper head={`Reverse Mapper | ${REVERSE_MATCHER_ROUTES.REVERSE_SUBTITLE}`} title={REVERSE_MATCHER_ROUTES.REVERSE_SUBTITLE}>
		<Box width={1} height={1} position="relative" top={20}>
			{ isReverseMatcherLoading.value
				? <MatchersSkeleton />
				: <ReverseMatcherContent hasIdMapping={new URLSearchParams(window.location.search).get('id_mapping') !== null} />
			}
		</Box>
	</PageWrapper>
}